import HotelCardMapTitleBlock from './HotelCardMapTitleBlock';

export default HotelCardMapTitleBlock;
